import timeToSeconds from "astrid-helpers/src/timeToSeconds";

export default function durationToSeconds(duration) {
	return timeToSeconds(duration);
}